import React from 'react'
import ContactForm from '../ContactFrom/ContactForm'

const ContactSection = (props) => {
    return (
        <section className="contact_section section_space" style={{ backgroundColor: '#F5F5F5' }}>
            <div className="container">
                <div className="section_space pt-0 pb-0">
                    <div className="row justify-content-lg-between">
                        <div className="col-lg-8">
                            <div className="contact_form mb-0">
                                <h3 className="details_item_info_title text-center mb-1">Send Us Your Details For Customized <br/> Solutions</h3>
                                <p className="mb-5 text-center">
                                    * All Fields are compulsory
                                </p>
                                <ContactForm />
                            </div>
                        </div>
                        <div className="col-lg-5">
                            
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ContactSection;